
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightAolOff as ObiLightAolOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-aol-off.js';
 
 
 

 
 export const ObiLightAolOff = createComponent({
   react: React,
   tagName: 'obi-light-aol-off',
   elementClass: ObiLightAolOffElement,
   events: {
     
   }
  });
 
 